export default {
  fourDetail: {
    component: () =>
      import(
        /* webpackChunkName: "system_detail" */ "@/mods/system/fourPropertyDesign/detailView/FourDesignDetail"
      ),
  },
};
